module.exports = __webpack_public_path__ + "img/logo.06133523.png";